import { createSlice } from '@reduxjs/toolkit';

export const messageSlice = createSlice({
  name: 'message',
  initialState: {
    messageBySessionId: {},
    loading: false,
    error: null,
  },
  reducers: {
    setMessageBySessionId: (state, action) => {
      const { messageSessionId, messages } = action.payload;
      state.messageBySessionId[messageSessionId] = messages;
      state.loading = false;
      state.error = null;
    },
    addTemporaryMessage: (state, action) => {
      const { messageSessionId, message } = action.payload;
      if (!state.messageBySessionId[messageSessionId]) {
        state.messageBySessionId[messageSessionId] = [];
      }
      state.messageBySessionId[messageSessionId].unshift({
        ...message
      });
    },
    resetMessages: (state) => {
      state.messageBySessionId = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setMessageBySessionId,
  addTemporaryMessage,
  resetMessages,
} = messageSlice.actions;

//Selectors
export const selectMessages = (state) => state.message;

export default messageSlice.reducer;